import { render } from "./AppLoding.vue?vue&type=template&id=7baeb232&scoped=true"
import script from "./AppLoding.vue?vue&type=script&lang=js"
export * from "./AppLoding.vue?vue&type=script&lang=js"

import "./AppLoding.vue?vue&type=style&index=0&id=7baeb232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7baeb232"]])

export default __exports__